class LoadingButton {
    constructor(button, options = {}) {
        this.button = button.jquery ? button[0] : button;
        this.options = options;
        this.originalText = this.button.textContent;
        this.originalClasses = this.button.className;
    }

    start() {
        this.button.classList.add('btn-loading');
        this.button.disabled = true;
    }

    stop(text = null, color = null) {
        this.button.classList.remove('btn-loading');
        this.button.disabled = false;

        if (text) {
            this.button.textContent = text;

            if (!this.originalClasses) {
                this.originalClasses = this.button.className;
            }
            if (color == "danger") {
                this.button.className = this.originalClasses + ' bg-red-500 hover:bg-red-600';
            } else if (color == "success") {
                this.button.className = this.originalClasses + ' bg-green-600 hover:bg-green-600';
            } else if (color == "info") {
                this.button.className = this.originalClasses + ' bg-blue-500 hover:bg-blue-600';
            } else if (color == "warning") {
                this.button.className = this.originalClasses + ' bg-yellow-500 hover:bg-yellow-600';
            } else {
                this.button.className = this.originalClasses + ' ' + color;
            }
        } else {
            this.button.textContent = this.originalText;
            if (this.originalClasses) {
                this.button.className = this.originalClasses;
            }
        }
    }

    reset() {
        this.stop();
    }
}